import { SMALL } from './constants/size';

// Variants //
export const isSecondary = (value) => value === 'secondary';
export const isStandard = (value) => value === 'standard';

// Sizes //
export const isSmall = (value) => value === SMALL;
